import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, ArrowRight } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_planet-gyaan-edu/artifacts/no8w3qt3_Untitled%20design-73.png';

const Footer = () => (
  <footer data-testid="main-footer" className="bg-white border-t-2 border-gray-100">
    <div className="container mx-auto px-6 lg:px-16 py-16">
      <div className="grid md:grid-cols-4 gap-10">
        <div>
          <div className="mb-5">
            <img src={LOGO} alt="Planet Gyaan" className="h-14 w-auto" />
          </div>
          <p className="text-[#52525B] font-body text-sm leading-relaxed">
            Empowering students since 2013. Building confidence, clarity and long-term success through quality education in Mathematics & Science.
          </p>
          {/* Social Media */}
          <div className="flex gap-3 mt-5">
            <a href="https://www.instagram.com/planetgyaan" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="w-9 h-9 rounded-lg bg-[#F2C402]/10 flex items-center justify-center hover:bg-[#F2C402] group transition-colors" aria-label="Instagram">
              <svg className="w-4 h-4 text-[#52525B] group-hover:text-[#0A0A0A] transition-colors" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
            </a>
            <a href="https://www.facebook.com/planetgyaan" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="w-9 h-9 rounded-lg bg-[#F2C402]/10 flex items-center justify-center hover:bg-[#F2C402] group transition-colors" aria-label="Facebook">
              <svg className="w-4 h-4 text-[#52525B] group-hover:text-[#0A0A0A] transition-colors" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="https://www.youtube.com/@planetgyaan" target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" className="w-9 h-9 rounded-lg bg-[#F2C402]/10 flex items-center justify-center hover:bg-[#F2C402] group transition-colors" aria-label="YouTube">
              <svg className="w-4 h-4 text-[#52525B] group-hover:text-[#0A0A0A] transition-colors" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-sans font-bold text-base mb-5 text-[#121212]">Quick Links</h3>
          <div className="space-y-3">
            <Link to="/" data-testid="footer-link-home" className="block text-[#52525B] hover:text-[#E9811F] transition-colors text-sm font-body">Regular Batch Tuitions</Link>
            <Link to="/doubt-clearing" data-testid="footer-link-doubt" className="block text-[#52525B] hover:text-[#E9811F] transition-colors text-sm font-body">1:1 Doubt Clearing</Link>
            <Link to="/career-counselling" data-testid="footer-link-career" className="block text-[#52525B] hover:text-[#E9811F] transition-colors text-sm font-body">Career Counselling</Link>
            <Link to="/best-cbse-coaching-santacruz" data-testid="footer-link-best" className="block text-[#52525B] hover:text-[#E9811F] transition-colors text-sm font-body">Best CBSE Coaching</Link>
          </div>
        </div>

        <div>
          <h3 className="font-sans font-bold text-base mb-5 text-[#121212]">Our Branches</h3>
          <div className="space-y-4">
            <div>
              <span className="text-[#121212] font-bold text-sm font-body block">Santacruz West (Main)</span>
              <span className="text-[#52525B] text-xs font-body">CBSE Grades 8-12, Math & Science</span>
            </div>
            <div>
              <span className="text-[#121212] font-bold text-sm font-body block">Vile Parle West</span>
              <span className="text-[#52525B] text-xs font-body">JEE & NEET Specialized</span>
            </div>
          </div>
        </div>

        <div>
          <h3 className="font-sans font-bold text-base mb-5 text-[#121212]">Contact Us</h3>
          <div className="space-y-3">
            <a href="tel:+919930010800" data-testid="footer-phone" className="flex items-start gap-3 text-[#52525B] hover:text-[#E9811F] transition-colors text-sm font-body">
              <Phone className="w-4 h-4 mt-0.5 text-[#F2C402] shrink-0" />
              +91 99300 10800
            </a>
            <a href="tel:+919930030600" data-testid="footer-phone-2" className="flex items-start gap-3 text-[#52525B] hover:text-[#E9811F] transition-colors text-sm font-body">
              <Phone className="w-4 h-4 mt-0.5 text-[#F2C402] shrink-0" />
              +91 99300 30600
            </a>
            <div className="flex items-start gap-3 text-[#52525B] text-sm font-body">
              <MapPin className="w-4 h-4 mt-0.5 text-[#F2C402] shrink-0" />
              <span>8, Ground floor, Tirupati Shopping Centre, S.V. RD. Near Riyaasat Store, Opp Kora and Phiroze Dastoor Store. Santacruz West, Mumbai, Maharashtra 400054</span>
            </div>
            <div className="flex items-start gap-3 text-[#52525B] text-sm font-body">
              <Clock className="w-4 h-4 mt-0.5 text-[#F2C402] shrink-0" />
              Mon - Sat: 9:00 AM - 8:00 PM
            </div>
            <div className="mt-3 rounded-lg overflow-hidden border border-gray-200">
              <iframe
                data-testid="google-maps-embed"
                src="https://maps.google.com/maps?q=Planet+Gyaan+Tirupati+Shopping+Center+Swami+Vivekanand+Rd+Santacruz+West+Mumbai&t=&z=16&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="120"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Planet Gyaan Location"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-[#52525B]/50 text-sm font-body">&copy; {new Date().getFullYear()} Planet Gyaan. All rights reserved.</p>
        <a
          href="https://wa.me/919930010800"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-cta"
          className="flex items-center gap-2 bg-[#25D366] text-white px-5 py-2.5 rounded-xl font-bold text-sm hover:brightness-110 transition-all"
        >
          WhatsApp Us <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
